export const getUserText = (): string => {
  return `[{
    "_id": {
      "$oid": "625439fad02e0433d8fd3d12"
    },
    "document": null,
    "_created": {
      "$date": "2022-04-11T14:23:54.473Z"
    },
    "_modified": {
      "$date": "2022-04-11T14:24:08.359Z"
    },
    "email": "erikbergmeyer@webstollen.de",
    "password": "$2a$14$aLda/BrnHl20iVppF.otXup0h3fRxsCwb/vkE1MIX4LkYLqxMCFPq",
    "gen_password": "",
    "promotion": "",
    "status": 1,
    "actiated_at": {
      "$date": {
        "$numberLong": "-62135596800000"
      }
    },
    "last_login": {
      "$date": "2022-04-11T14:23:56.613Z"
    },
    "access_token": [
      {
        "token": "ea87303d6af204ba347264603d43fcc1e6bf703ab3c91c1a115ea624a73bd72b",
        "refresh_token": "654b93c1771431af70f1c5b74593d7787cde7729bd632b458eca0449c48bd035",
        "created_at": {
          "$date": "2022-04-11T14:23:56.612Z"
        },
        "location": "Regensburg, Germany (DE)",
        "user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.75 Safari/537.36",
        "ip_address": "95.130.163.0",
        "push_device_id": "",
        "push_device_type": "",
        "last_action": {
          "$date": "2022-04-11T14:24:08.352Z"
        }
      }
    ],
    "role": "user",
    "prename": "Erik",
    "lastname": "Bergmeyer",
    "password_reset_code": "",
    "password_reset_date": {
      "$date": {
        "$numberLong": "-62135596800000"
      }
    },
    "opt_in_code": "cb9964ba80c3348425af37e1831f6be4",
    "sendinblue": {
      "id": 505927
    },
    "module_settings": {}
  }]`
}

export const getCompanyText = (): string => {
  return `[{
    "_id": {
      "$oid": "5bf513c9cf848d556ada9852"
    },
    "shops": [
      {
        "_id": {
          "$oid": "5c98c044cf848d0c4a513dfb"
        },
        "_created": {
          "$date": "2019-03-25T11:49:24.530Z"
        },
        "_modified": {
          "$date": "2022-04-12T12:25:02.372Z"
        },
        "client_id": "43d59e946f66c2bfa2ad865b596506f4f22d44ffc678a0fbf3246f4d29184446",
        "secret_token": "9fd2268c871411347c33e6220b336bd6a31987a413a9d28370ccda4af198c6ad",
        "endpoint": "https://www.webstollen.de/includes/plugins/ws_dashbar/api.php",
        "version": "200",
        "master": {
          "$oid": "5bf513c9cf848d556ada9852"
        },
        "favicon": "https://www.webstollen.de/_icons/favicon.gif",
        "status": {
          "active": true,
          "interval": 5,
          "last_check": {
            "$date": "2022-04-12T12:25:02.142Z"
          },
          "errors": 2,
          "history": {
            "1649739603": {
              "rtt": 103051848,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649742601": {
              "rtt": 146786128,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649744402": {
              "rtt": 103594798,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649752802": {
              "rtt": 103912068,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649759701": {
              "rtt": 103408269,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649760002": {
              "rtt": 94049814,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649760902": {
              "rtt": 124169887,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649761502": {
              "rtt": 103240586,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649762402": {
              "rtt": 110456355,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649762702": {
              "rtt": 116002043,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649763002": {
              "rtt": 98036370,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649764202": {
              "rtt": 140367805,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649764802": {
              "rtt": 93676385,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649765402": {
              "rtt": 107006979,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649766302": {
              "rtt": 105332821,
              "pluginversion": 200,
              "shopversion": "406.0",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            }
          }
        },
        "name": "",
        "software": "",
        "software_version": "",
        "currency": ""
      },
      {
        "_id": {
          "$oid": "5e95867068bd4564692de9a9"
        },
        "_created": {
          "$date": "2020-04-14T09:46:24.392Z"
        },
        "_modified": {
          "$date": "2022-04-12T12:25:02.140Z"
        },
        "client_id": "595f6168e06ec37404633e1307040cf949bb9cd5930fa19f4e50530303d68e30",
        "secret_token": "9552dca26f96e10c7e9c61ba19e57b43cd33649ab809865c114e1c9c5eb34901",
        "endpoint": "https://dashbar.v4.webstollen.com/includes/plugins/ws_dashbar/api.php",
        "version": "107",
        "master": {
          "$oid": "5bf513c9cf848d556ada9852"
        },
        "favicon": "https://dashbar.v4.webstollen.com/templates/Evo/favicon.ico",
        "status": {
          "active": true,
          "interval": 5,
          "last_check": {
            "$date": "2022-04-12T12:25:02.047Z"
          },
          "errors": 0,
          "history": {
            "1649747401": {
              "rtt": 36448963,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649749202": {
              "rtt": 35413061,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649749801": {
              "rtt": 35025453,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649754002": {
              "rtt": 34735182,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649754601": {
              "rtt": 38439575,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649757007": {
              "rtt": 34622077,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649759102": {
              "rtt": 39129324,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649760601": {
              "rtt": 37557571,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649763002": {
              "rtt": 34905669,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649763602": {
              "rtt": 38220003,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649764202": {
              "rtt": 43651769,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649764802": {
              "rtt": 35142104,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649765402": {
              "rtt": 40528999,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649765702": {
              "rtt": 36930387,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649766302": {
              "rtt": 43792327,
              "pluginversion": 107,
              "shopversion": "406.17",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "apc",
              "caching_activated": true,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            }
          }
        },
        "name": "",
        "software": "JTL-Shop",
        "software_version": "",
        "currency": "&euro;"
      },
      {
        "_id": {
          "$oid": "5dd6442568bd454d6c16b7b8"
        },
        "_created": {
          "$date": "2019-11-21T08:00:37.466Z"
        },
        "_modified": {
          "$date": "2022-04-12T10:00:08.691Z"
        },
        "client_id": "692b5439b09e23ca47b91a24115bdc6c94c24558af8f98fa5f5c6e43a19b5cce",
        "secret_token": "835b63651ccbb08fb3f8197bd1e6209458c442207fe95ee2f15a1d43dc5c1180",
        "endpoint": "https://www.fischfuttertreff.de/includes/plugins/ws_dashbar/api.php",
        "version": "107",
        "master": {
          "$oid": "5dd54ad868bd454d6c16b4ea"
        },
        "favicon": "https://www.fischfuttertreff.de/templates/fischfuttertreff/themes/base/images/favicon-jtl.ico",
        "status": {
          "active": true,
          "interval": 1440,
          "last_check": {
            "$date": "2022-04-11T20:45:06.826Z"
          },
          "errors": 2,
          "history": {
            "1642862211": {
              "rtt": 123455652,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1645639228": {
              "rtt": 117393629,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1646938522": {
              "rtt": 122186759,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1647718205": {
              "rtt": 111865222,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1648237502": {
              "rtt": 95976510,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1648324229": {
              "rtt": 118748163,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1648410912": {
              "rtt": 109171694,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1648757425": {
              "rtt": 106927588,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1648930829": {
              "rtt": 109324150,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649017532": {
              "rtt": 118842971,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649277031": {
              "rtt": 94757825,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649363730": {
              "rtt": 125749769,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649450403": {
              "rtt": 94684476,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649623232": {
              "rtt": 126520312,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1649709906": {
              "rtt": 98243222,
              "pluginversion": 107,
              "shopversion": "406.14",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "null",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            }
          }
        },
        "name": "",
        "software": "JTL-Shop",
        "software_version": "",
        "currency": "&euro;"
      },
      {
        "_id": {
          "$oid": "618d1d27d02e04311a786c28"
        },
        "_created": {
          "$date": "2021-11-11T13:39:51.044Z"
        },
        "_modified": {
          "$date": "2022-04-12T01:21:32.552Z"
        },
        "client_id": "88f839ab9cd531d911fb7d0d667e29b0397af55c2b19df1b2266ce834753f260",
        "secret_token": "710d5293dfc9ec66e0f60847a3f71c2681faaa93bfc79e32decdc1ca19e75e4f",
        "endpoint": "https://doofinder.v5.webstollen.com/plugins/ws5_dashbar/api.php",
        "version": "200",
        "master": {
          "$oid": "5bf513c9cf848d556ada9852"
        },
        "favicon": "https://doofinder.v5.webstollen.com/favicon-default.ico",
        "status": {
          "active": false,
          "interval": 5,
          "last_check": {
            "$date": "2022-04-11T12:40:02.180Z"
          },
          "errors": 3,
          "history": {
            "1636638002": {
              "rtt": 124313225,
              "pluginversion": 200,
              "shopversion": "",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1636638603": {
              "rtt": 131350333,
              "pluginversion": 200,
              "shopversion": "",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            },
            "1636639203": {
              "rtt": 130469143,
              "pluginversion": 200,
              "shopversion": "",
              "status_code": 200,
              "maintenance_mode": false,
              "caching_method": "file",
              "caching_activated": false,
              "visitors": [],
              "referer": [],
              "orders": [],
              "statistics": {}
            }
          }
        },
        "name": "",
        "software": "JTL-Shop 5",
        "software_version": "",
        "currency": "&euro;"
      }
    ],
    "owner": [
      {
        "_id": {
          "$oid": "5bf513c9cf848d556ada9851"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T08:14:01.273Z"
        },
        "_modified": {
          "$date": "2022-04-11T08:53:35.623Z"
        },
        "email": "proske@webstollen.de",
        "password": "$2a$14$4TVfLxh2oBEiC8jjInv/EOBzOUavzHg02ZQ7gl63NeOdQXvg7gQK6",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": "2018-11-21T12:04:07.507Z"
        },
        "last_login": {
          "$date": "2022-03-15T13:31:43.259Z"
        },
        "access_token": [
          {
            "token": "0e845f76242fc8feb7df41c737f1ddcba250afb09a1f1ab1f760a26e35c1e011",
            "refresh_token": "f0381d6332490217942a10cef2aa0cd3f540e1283ca3aa7bd4c5eaa0287006b3",
            "created_at": {
              "$date": "2022-03-15T13:31:43.259Z"
            },
            "location": "Hamburg, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.51 Safari/537.36",
            "ip_address": "134.101.166.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-04-11T08:53:35.623Z"
            }
          }
        ],
        "role": "root",
        "prename": "Christian",
        "lastname": "Proske",
        "password_reset_code": "2373ebca09ffacd03552417075eac91e",
        "password_reset_date": {
          "$date": "2021-11-23T09:48:45.315Z"
        },
        "opt_in_code": "8971888bc7e961a88efda54864e3fbdb",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "D90",
              "refresh": 10
            },
            "order": {
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "sales": {
              "details": true,
              "active": true,
              "interval": "D7",
              "refresh": 10
            },
            "conversion": {
              "details": true,
              "active": true,
              "interval": "D7",
              "refresh": 30
            },
            "renner": {
              "active": true,
              "interval": "Y2021",
              "refresh": 60
            }
          }
        }
      }
    ],
    "users": [
      {
        "_id": {
          "$oid": "5bf513c9cf848d556ada9851"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T08:14:01.273Z"
        },
        "_modified": {
          "$date": "2022-04-11T08:53:35.623Z"
        },
        "email": "proske@webstollen.de",
        "password": "$2a$14$4TVfLxh2oBEiC8jjInv/EOBzOUavzHg02ZQ7gl63NeOdQXvg7gQK6",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": "2018-11-21T12:04:07.507Z"
        },
        "last_login": {
          "$date": "2022-03-15T13:31:43.259Z"
        },
        "access_token": [
          {
            "token": "0e845f76242fc8feb7df41c737f1ddcba250afb09a1f1ab1f760a26e35c1e011",
            "refresh_token": "f0381d6332490217942a10cef2aa0cd3f540e1283ca3aa7bd4c5eaa0287006b3",
            "created_at": {
              "$date": "2022-03-15T13:31:43.259Z"
            },
            "location": "Hamburg, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.51 Safari/537.36",
            "ip_address": "134.101.166.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-04-11T08:53:35.623Z"
            }
          }
        ],
        "role": "root",
        "prename": "Christian",
        "lastname": "Proske",
        "password_reset_code": "2373ebca09ffacd03552417075eac91e",
        "password_reset_date": {
          "$date": "2021-11-23T09:48:45.315Z"
        },
        "opt_in_code": "8971888bc7e961a88efda54864e3fbdb",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "D90",
              "refresh": 10
            },
            "order": {
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "sales": {
              "details": true,
              "active": true,
              "interval": "D7",
              "refresh": 10
            },
            "conversion": {
              "details": true,
              "active": true,
              "interval": "D7",
              "refresh": 30
            },
            "renner": {
              "active": true,
              "interval": "Y2021",
              "refresh": 60
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bf515a6cf848d556ada985b"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T08:21:58.941Z"
        },
        "_modified": {
          "$date": "2022-04-08T13:00:00.849Z"
        },
        "email": "barbian@webstollen.de",
        "password": "$2a$14$FzUHwTtpAOYVaWxX7mPYeuvPY6yYGtjqoD8/WLAEsOY0ZCYqg0OxW",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2022-02-25T07:05:42.382Z"
        },
        "access_token": [
          {
            "token": "0e53fcfa1d6d21dc5182d326db1ff486fabcf7290e89cf675200e7e07d1e6be7",
            "refresh_token": "a2a688ae2e1bea323a6e441961e0c4d31ea1d3f527c1acf7d96d3a1abf318bf4",
            "created_at": {
              "$date": "2022-02-25T07:05:42.382Z"
            },
            "location": "Regensburg, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.3 Safari/605.1.15",
            "ip_address": "95.130.160.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-04-08T13:00:00.849Z"
            }
          }
        ],
        "role": "root",
        "prename": "Florian",
        "lastname": "Barbian",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": "2020-09-10T10:03:55.560Z"
        },
        "opt_in_code": "37df7cb901c20d0e759d338beef36195",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "D30",
              "refresh": 10
            },
            "renner": {
              "active": true,
              "interval": "Y2021",
              "refresh": 60
            },
            "order": {
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "conversion": {
              "details": true,
              "active": true,
              "interval": "D90",
              "refresh": 30
            },
            "sales": {
              "details": true,
              "active": true,
              "interval": "D1",
              "refresh": 10
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bf515d8cf848d556ada985c"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T08:22:48.493Z"
        },
        "_modified": {
          "$date": "2022-03-29T11:24:17.905Z"
        },
        "email": "stepanek@webstollen.de",
        "password": "$2a$14$cGF1x.V/OjHwBhT68upf2.deqhrs4lLzmn2msUdLT7wt9rltCUOxm",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2022-01-04T14:37:27.355Z"
        },
        "access_token": [
          {
            "token": "dff6ff3b8a5d0d09277181397ff5a1942f160410029c8c64f6eb653edb8a64b7",
            "refresh_token": "b71169189167179c401161985ad42dec0c9f3143e3a4141063857b37d577b985",
            "created_at": {
              "$date": "2022-01-04T14:37:27.354Z"
            },
            "location": "Regensburg, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36",
            "ip_address": "80.209.197.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-03-29T11:24:17.904Z"
            }
          }
        ],
        "role": "root",
        "prename": "Michael",
        "lastname": "Stepanek",
        "password_reset_code": "ee13ca981c65ff923532b87662097ddd",
        "password_reset_date": {
          "$date": "2018-11-21T12:06:29.576Z"
        },
        "opt_in_code": "47cfcb3a1e0747bd8b081bb852783de9",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "sales": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 10
            },
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D90",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "D1",
              "refresh": 10
            },
            "order": {
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "renner": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60
            },
            "conversion": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 30
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bf51906cf848d556ada985d"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T08:36:22.935Z"
        },
        "_modified": {
          "$date": "2022-04-01T08:52:03.936Z"
        },
        "email": "morokane@webstollen.de",
        "password": "$2a$14$EceesAT/D0OEKJpssZJD5.EoEugMVm16QxTfnqJGqhioxD7NSDOEm",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2022-04-01T08:51:57.171Z"
        },
        "access_token": [
          {
            "token": "af42d9c6d5070df7e4f7a275901a2adc17e5f50befe141e5af3947693c790685",
            "refresh_token": "05541f9e464ba78b100fd526441bcd08c739de58adb6e958e24502da0c3488d4",
            "created_at": {
              "$date": "2022-04-01T08:51:57.171Z"
            },
            "location": "Regensburg, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.83 Safari/537.36",
            "ip_address": "95.130.160.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-04-01T08:52:03.936Z"
            }
          }
        ],
        "role": "admin",
        "prename": "Kabelo",
        "lastname": "Morokane",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": "2019-12-10T09:40:00.496Z"
        },
        "opt_in_code": "315e3db91f9b549207bd2115cc26108f",
        "sendinblue": {
          "id": 488772
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "sales": {
              "details": true,
              "active": true,
              "interval": "Q1",
              "refresh": 10
            },
            "renner": {
              "active": true,
              "interval": "M7",
              "refresh": 60
            },
            "conversion": {
              "active": true,
              "interval": "M7",
              "refresh": 30
            },
            "order": {
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "I2016-07-20#2020-02-16",
              "refresh": 10
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bf5233dcf848d556ada985e"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T09:19:57.049Z"
        },
        "_modified": {
          "$date": "2022-03-27T12:18:19.143Z"
        },
        "email": "moeller@webstollen.de",
        "password": "$2a$14$.U5ChATle83RV7CfYZXkEuWQ3.Exb8UhDRaJN5To2CaIMWFPeZlLG",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2022-03-22T15:15:36.757Z"
        },
        "access_token": [
          {
            "token": "bc47f9215796a181f36b58a54cd705225491e2d915c3a457baf993f8ba286ea9",
            "refresh_token": "fb58f9b5441e7eb125c47f76d51ead54b94d97d953a8a271433f2428095bdef5",
            "created_at": {
              "$date": "2022-01-13T15:09:40.586Z"
            },
            "location": "Lahnstein, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36",
            "ip_address": "95.91.223.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-03-22T15:14:00.825Z"
            }
          },
          {
            "token": "29f742103a5cdfd4553b14b72e9205a3996464f41140302cfef214efd191dcf7",
            "refresh_token": "60a87f1795775da90a2b0e989e4500a59d25720d38d32af65f81e7660013139b",
            "created_at": {
              "$date": "2022-03-17T15:06:39.314Z"
            },
            "location": "Ronnenberg, Germany (DE)",
            "user_agent": "dash.bar app/1.0.1",
            "ip_address": "89.247.145.0",
            "push_device_id": "fy0Fh-laIZ8:APA91bGZrGxjEhyRbZKVhxU-TG0RVrVIrdtsbLhjlUa-2Gsvb6fY4F3cv6Xo1pUtVAfyagMHXtAPFH9EBWvS-L99ZvHmjjGu9nMOvuJ2H27y_EVvSXV90SuSUlW_nyOJHm3iO0gEMmPl",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-03-17T15:06:53.009Z"
            }
          },
          {
            "token": "a772f7f60db1ec373a3bdd3158bd5813bb07d2bd8315c5a27161ae2306d98141",
            "refresh_token": "95ff15a69e6e09e9d8cb847f449ee01787ec4bda586e9b69c92806928cbb380d",
            "created_at": {
              "$date": "2022-03-22T15:15:36.756Z"
            },
            "location": "Saarbrücken, Germany (DE)",
            "user_agent": "Mozilla/5.0 (Linux; Android 10; COL-L29) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.73 Mobile Safari/537.36",
            "ip_address": "95.90.204.0",
            "push_device_id": "",
            "push_device_type": "FCM",
            "last_action": {
              "$date": "2022-03-27T12:18:19.143Z"
            }
          }
        ],
        "role": "admin",
        "prename": "Nick Janik",
        "lastname": "Möller",
        "password_reset_code": "2e4729c82bec5880ecc7c03fb89bbc3d",
        "password_reset_date": {
          "$date": "2021-11-22T15:47:30.451Z"
        },
        "opt_in_code": "c2e8f371c240162a89f827bf280cc1ef",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "EventTracker": {
            "visitors": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 10
            }
          },
          "Analytics": {
            "renner": {
              "details": true,
              "active": true,
              "interval": "Y2021",
              "refresh": 60
            },
            "sales": {
              "details": true,
              "active": true,
              "interval": "Y2022",
              "refresh": 10
            },
            "conversion": {
              "details": true,
              "active": true,
              "interval": "D7",
              "refresh": 30
            },
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "Y2021",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "order": {
              "details": true,
              "active": true,
              "interval": "",
              "refresh": 60
            },
            "status": {
              "active": true,
              "interval": "Y2022",
              "refresh": 10
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bf593becf848d614ef2ac4d"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-21T17:19:58.435Z"
        },
        "_modified": {
          "$date": "2022-01-01T11:00:04.206Z"
        },
        "email": "klamer@webstollen.de",
        "password": "$2a$14$Ft.moTiqzunabJeDaaws1eJ19t8MkkTrKbYTS95Mx5lZzh3iCYipq",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2021-11-24T12:48:08.889Z"
        },
        "access_token": [],
        "role": "developer",
        "prename": "Florian",
        "lastname": "Klamer",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": "2018-12-10T09:28:55.231Z"
        },
        "opt_in_code": "59c9db474c1c7d2c16f306cc158483e6",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            },
            "status": {
              "active": true,
              "interval": "D1",
              "refresh": 10
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5bfd0c25cf848d47d204bac3"
        },
        "document": null,
        "_created": {
          "$date": "2018-11-27T09:19:33.995Z"
        },
        "_modified": {
          "$date": "2020-09-17T08:22:07.983Z"
        },
        "email": "facebook@webstollen.de",
        "password": "$2a$14$8mBM/fWwYiqhn/vAt..Opuuxhike./8a9jmTNUZeChBpWcCY361Ga",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "last_login": {
          "$date": "2018-11-27T09:19:37.020Z"
        },
        "access_token": [],
        "role": "user",
        "prename": "",
        "lastname": "",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "opt_in_code": "1707096ce46202afe630c8be1a5495a8",
        "sendinblue": {
          "id": 499104
        },
        "module_settings": {}
      },
      {
        "_id": {
          "$oid": "5e3a9d6f68bd45147fc260cb"
        },
        "document": null,
        "_created": {
          "$date": "2020-02-05T10:48:15.531Z"
        },
        "_modified": {
          "$date": "2021-10-20T10:00:01.934Z"
        },
        "email": "erben@webstollen.de",
        "password": "$2a$14$SHvYr5Quel8z.JgeEEjKk.t6knq9VIhjMsgd7UecusXgh88SfJ5Sq",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": "2020-02-05T10:48:42.212Z"
        },
        "last_login": {
          "$date": "2021-08-23T07:44:00.315Z"
        },
        "access_token": [],
        "role": "developer",
        "prename": "Leopold",
        "lastname": "Erben",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "opt_in_code": "",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5e3bcef068bd45147fc26a4c"
        },
        "document": null,
        "_created": {
          "$date": "2020-02-06T08:31:44.498Z"
        },
        "_modified": {
          "$date": "2021-12-11T17:00:04.035Z"
        },
        "email": "schillings@webstollen.de",
        "password": "$2a$14$k84G6cUTx4.h6um7kZTiyeCVGbb1MUPxzCA/wIdEjDfhMETGJ3Rn.",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": "2020-02-06T08:32:16.942Z"
        },
        "last_login": {
          "$date": "2021-09-29T09:34:48.424Z"
        },
        "access_token": [],
        "role": "developer",
        "prename": "Alexander",
        "lastname": "Schillings",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "opt_in_code": "",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "Analytics": {
            "status": {
              "active": true,
              "interval": "D7",
              "refresh": 10
            },
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            }
          }
        }
      },
      {
        "_id": {
          "$oid": "5f7f242668bd4533f7fcfcab"
        },
        "document": null,
        "_created": {
          "$date": "2020-10-08T14:37:26.207Z"
        },
        "_modified": {
          "$date": "2021-07-08T09:05:04.958Z"
        },
        "email": "heuberger@webstollen.de",
        "password": "$2a$14$vD31f4SrDd5MJMmSXuGmpuHtBjPWXZxjD0FWBpliR7b/1FkUT48/e",
        "gen_password": "",
        "promotion": "",
        "status": 2,
        "actiated_at": {
          "$date": "2020-10-08T14:37:56.838Z"
        },
        "last_login": {
          "$date": "2021-07-08T09:04:50.169Z"
        },
        "access_token": [],
        "role": "user",
        "prename": "Lukas",
        "lastname": "Heuberger",
        "password_reset_code": "",
        "password_reset_date": {
          "$date": {
            "$numberLong": "-62135596800000"
          }
        },
        "opt_in_code": "",
        "sendinblue": {
          "id": 0
        },
        "module_settings": {
          "Analytics": {
            "kampagne": {
              "details": true,
              "active": true,
              "interval": "D30",
              "refresh": 60,
              "selected": [
                0,
                1,
                2
              ]
            }
          }
        }
      }
    ],
    "name": "WebStollen GmbH",
    "address_1": "Prinz-Ludwig-Str. 15",
    "address_2": "",
    "city": "Regensburg",
    "zip": "93055",
    "country": "DE",
    "ust_id": "DE815694545",
    "product": {
      "_id": {
        "$oid": "5d23570006023629213d4b57"
      },
      "_created": {
        "$date": "2019-08-27T13:28:52.014Z"
      },
      "_modified": {
        "$date": "2019-08-27T13:28:52.014Z"
      },
      "name": "pro",
      "description": "Keine Wünsche offen lassen",
      "add_ons": [
        {
          "internal_name": "user",
          "name": "User",
          "amount": 15,
          "description": "bis zu 15 Benutzer gleichzeitig ",
          "price": 0,
          "public": true
        },
        {
          "internal_name": "shop",
          "name": "Domains",
          "amount": 5,
          "description": "Bis zu 5 Shops verbinden",
          "price": 0,
          "public": true
        },
        {
          "internal_name": "access_token",
          "name": "Geräte/User",
          "amount": 5,
          "description": "Jeder Nutzer kann bei 5 Geräten gleichzeitig angemeldet sein ",
          "price": 0,
          "public": true
        },
        {
          "internal_name": "push_notification",
          "name": "Push/Tag",
          "amount": -1,
          "description": "Lass dich per Push über wichtige Ereignisse benachrichtigen ",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "report_daily",
          "name": "täglicher Report",
          "amount": 1,
          "description": "Tägliche Reporte",
          "price": 0,
          "public": true
        },
        {
          "internal_name": "report_weekly",
          "name": "wöchentlicher Report",
          "amount": 1,
          "description": "Wöchentlicher Reporte",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "report_monthly",
          "name": "monatlicher Report",
          "amount": 1,
          "description": "Monatliche Reporte",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "report_yearly",
          "name": "jährlicher Report",
          "amount": 1,
          "description": "Jährliche Reporte",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "plugin_flatrate",
          "name": "Plugin flatrate",
          "amount": 1,
          "description": "Nutze kostenlos ausgewählte WebStollen Plugins***",
          "price": 0,
          "public": true
        },
        {
          "internal_name": "geoip",
          "name": "GeoIP Requests/Tag",
          "amount": -1,
          "description": "Sieh, woher deine Kunden kommen ",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "watcher_ping",
          "name": "min Shop-Watcher Interval",
          "amount": 5,
          "description": "Alle 5 Minuten prüft der Watcher deinen Shop",
          "price": 0,
          "public": false
        },
        {
          "internal_name": "extended_filters",
          "name": "Erweiterte Filter",
          "amount": 1,
          "description": "Filtere deine Widgets nach deinen Vorlieben ",
          "price": 0,
          "public": false
        }
      ],
      "price": 0,
      "price_yearly": 299,
      "uvp": 49,
      "public": true,
      "default": false,
      "default_free": false,
      "sort": 4,
      "setup": 0,
      "canceled": {
        "$date": "2021-01-01T00:00:00Z"
      },
      "notified": {
        "$date": {
          "$numberLong": "-62135596800000"
        }
      },
      "valid": {
        "start_date": {
          "$date": "2019-10-01T00:00:02.952Z"
        },
        "end_date": {
          "$date": "2035-01-01T00:00:00Z"
        }
      },
      "invoice": false,
      "billingcycle": "none",
      "color": "#73167D"
    },
    "settings": {
      "developer": {
        "gitlab_access_token": "8976hc8x6fNs3P61oZjC",
        "gitlab_deploy_key": "-----BEGIN RSA PRIVATE KEY-----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\\n-----END RSA PRIVATE KEY-----",
        "base_plugins": [
          {
            "id": 249,
            "name": "Base Plugin Skeleton"
          },
          {
            "id": 328,
            "name": "Base Plugin Skeleton - no licence"
          }
        ],
        "plugin_groups": [
          {
            "id": 5,
            "name": "JTL Shop - Plugins"
          },
          {
            "id": 117,
            "name": "Moche Plugins"
          },
          {
            "id": 145,
            "name": "JTL Shop 5 - Plugins"
          }
        ]
      }
    },
    "account": {
      "balance": 0,
      "customer_id": "cst_HwFyRfUVeu",
      "mandate_id": "",
      "booking_id": "",
      "last_id": "",
      "retries": 0
    }
  }]`
}
